import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { MainAppState } from "../appState/models";

const selectFormValidityState = (state: MainAppState) => state.formValidity;

export const selectAllFormValidities = createDraftSafeSelector(
  selectFormValidityState,
  (formValidityState) => formValidityState,
);

export const selectFormValidityByKey = (formKey: string) =>
  createDraftSafeSelector(
    selectFormValidityState,
    (state) => state.formValidity[formKey],
  );
